import { useEffect, memo, useContext, useCallback } from "react"
import { useRecoilValue } from "recoil"
import { useRecoilState } from "recoil"
import { SDKContext } from "src/context/SDKContext"
import { useInspirations } from "src/hooks/useInspirations"
import { Inspiration } from "src/components/views/avatars/components/Inspiration"
import { avatarCommunication } from "src/conditionals/Avatar/AvatarCommunication"
import { queuedInspirationAtom } from "src/recoil/atoms/inspirations"
import { InspirationModel } from "src/components/views/avatars/components/Inspirations"
import { trulienceAtom } from "src/recoil/atoms/trulience"
import ScrollableBlurList from "src/components/common/ScrollableBlurList"
import { useCurrentAvatarInfo } from "src/conditionals/Avatar"
import { CloseTabsIcon } from "src/components/mediaPanel/small-view/full-screen-mobile-interface/close-tab-icon"
import { viewDependingLayoutAtom } from "src/recoil/atoms/view"
import { Box } from "@chakra-ui/react"
import { currentChatGenerationAtom } from "src/recoil/atoms/chats"

type InspirationsTabViewProps = {
  isMobile?: boolean
  openChat?: () => void
}

export const InspirationsTabView = memo(
  ({ isMobile = true, openChat }: InspirationsTabViewProps) => {
    const meetingClient = useContext(SDKContext)
    const avatarConfig = useCurrentAvatarInfo()

    const { inspirations } = useInspirations()
    const [queuedInspiration, setQueuedInspiration] = useRecoilState(
      queuedInspirationAtom
    )
    const { iframeHasLoaded } = useRecoilValue(trulienceAtom)
    const { isLandscape, isTransparent } = useRecoilValue(
      viewDependingLayoutAtom
    )
    const generation = useRecoilValue(currentChatGenerationAtom)

    const handleSendInspiration = useCallback(
      async (inspiration: InspirationModel) => {
        meetingClient?.sendPublicChat(
          !!inspiration.chatContent
            ? inspiration.chatContent
            : inspiration.title,
          undefined,
          null,
          undefined,
          avatarConfig?.id?.toString(),
          generation
        )
        avatarCommunication.sendMessage(inspiration.prompt)
      },
      [meetingClient, generation, avatarConfig?.id?.toString()]
    )

    return (
      <ScrollableBlurList
        items={inspirations}
        isMobile={isMobile}
        isTransparent={isTransparent}
        renderListHeader={() => {
          return (
            (isTransparent || isLandscape) && (
              <Box position={"relative"} width="36px" paddingBottom={"6px"}>
                <CloseTabsIcon position="unset" />
              </Box>
            )
          )
        }}
        renderItem={(inspiration, index) => (
          <Inspiration
            key={index}
            inspiration={inspiration}
            isTransparent={isTransparent}
            onClick={inspiration => {
              handleSendInspiration(inspiration)
              if (openChat) openChat()
            }}
          />
        )}
      />
    )
  }
)
